export const TABLE_SIZES_WITHOUT_NAME = {
  email: {
    lg: 5.5,
    md: 6,
    sm: 6.5,
    xs: 16
  },
  phoneNumber: {
    lg: 5.5,
    md: 6,
    sm: 6.5,
    xs: 16
  },
  nothing: {
    lg: 5,
    md: 4,
    sm: 3,
    xs: 0
  },
}
